function getObjectURL(file: File) {
  var url = '';
  if (window.URL != undefined) {
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}

export function selectImage(cb: (file: any, path: string) => void) {
  const file = document.createElement('input');
  file.type = 'file';
  file.accept = 'image/*';
  file.style.display = 'none';
  file.onchange = (e: Event) => {
    // @ts-ignore
    const files = e.target.files;
    const path = getObjectURL(files[0]!);
    cb(files[0], path);
    file.parentNode?.removeChild(file);
  };

  file.click();
}
